var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.1 102",
    style: {
      enableBackground: "new 0 0 491.1 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.5733,
    y1: -2.6865,
    x2: 85.5733,
    y2: 94.5282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    style: {
      stopColor: "#59C2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3273,
    style: {
      stopColor: "#0091D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#0091DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8364,
    style: {
      stopColor: "#1D2087"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.6,51.6c0-31.4-11.3-48.6-31.7-48.6c-19.1,0-33,18.4-45.3,34.5c-3.5,4.6-6.8,8.9-10.1,12.8 C70.3,64.5,52.7,72.6,34,72.6c-12.8,0-23.7-8.1-29.8-22.1L1.6,51c0,32.7,9.5,48.6,29.2,48.6c18.1,0,33-17.7,46.2-33.4 c4.4-5.2,8.5-10.1,12.5-14c14.3-14.1,32.2-22.5,47.7-22.5c12.8,0,23.4,8,29.8,22.4L169.6,51.6z M94.8,39.3 c12.5-16.4,25.4-33.4,43.1-33.4c15,0,24.6,10.6,27.7,30.2c-5.4-14-14.5-20.9-27.6-20.9c-16.5,0-32.9,14.3-45.5,27.1 C93.3,41.3,94,40.3,94.8,39.3z M34,75.4c13.4,0,26.3-4,37.2-11.4c-11,10.2-25,20.5-38.2,20.5c-14,0-22.3-7.5-26.8-24.6 C13.1,69.9,22.9,75.4,34,75.4z M30.7,96.8C16,96.8,7.7,87,5.2,66.3c4.1,11.6,11.8,21.2,27.8,21.2c14.4,0,29.5-11.3,40.9-22 C61.4,80.4,47.1,96.8,30.7,96.8z M137.1,27c-13.3,0-28.2,5.9-41.3,16c12.1-12.2,27.3-25,42.2-25c13.6,0,22.2,7.9,26.8,24.6 C157.9,32.5,148.3,27,137.1,27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.6,36.6c-9.8,0-17.9,6.5-19.5,13.1V37.6h-6.5v0.5v54.5h6.5h0.4V63.4c0-11.5,9.6-21.1,19.4-21.1 c8.8,0,15.6,5.9,15.6,14.8v35.6h7V55.3C406.6,45.3,397.4,36.6,383.6,36.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.8,
    y: 38.2,
    className: "st1",
    width: 6.5,
    height: 54.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.8,
    y: 5.3,
    className: "st1",
    width: 6.5,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485.3,72.8c-4.2,6.4-11.3,12.3-22,13.8c-12,1.8-19.9-5.3-22.4-8.6c-0.3-0.4,44.9-26.2,44.9-26.2 c-4.8-9.4-16.1-18.5-30-16.5c-19.4,2.9-28.1,19.5-26.2,33c2.6,17.6,17.6,26.3,34.3,23.9c10.9-1.6,20.2-7.9,25.5-15.3L485.3,72.8z  M436.2,67.2c-1.6-11,4.8-23.9,19.9-26.1c10.2-1.5,18.8,6.6,20.9,9.6l-38.8,22.9C437.6,72,436.5,68.9,436.2,67.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.2,93.4c-16.1,0-29.3-13.1-29.3-29.3c0-10.3,5.5-20,14.4-25.2l3.3,5.6c-6.9,4.1-11.2,11.6-11.2,19.6 c0,12.6,10.2,22.8,22.8,22.8c12.5,0,18.1-9.1,22.9-23.8C241.7,49.5,248,35,266.3,35c16.1,0,29.3,13.1,29.3,29.3 c0,10.3-5.5,20-14.4,25.2l-3.3-5.6c6.9-4.1,11.2-11.6,11.2-19.6c0-12.6-10.2-22.8-22.8-22.8c-12.7,0-17.9,8.3-22.9,23.6 C240.1,75,234,93.4,214.2,93.4L214.2,93.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.312bc391efab6bf1a7d19bc0a7741069.svg";
export { ForwardRef as ReactComponent };